import { IonButton, IonButtons, IonLabel, IonContent, IonHeader, IonIcon, IonImg, IonItem, IonList, IonMenuButton, IonPopover, IonText, IonToolbar, useIonRouter } from "@ionic/react";
import { appsOutline, logInOutline, logOutOutline, logOutSharp, menu, personCircleOutline, personOutline, statsChart, statsChartSharp } from "ionicons/icons";
import { chevronDown } from "ionicons/icons";
import React, { useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { User } from "../models/data";
import { translation } from "../models/translation";
import AuthServ from "../services/auth";

interface HeaderProps {
    loginB?: boolean
    user?: User | null,
    signIn?: any | null,
    removeUser?: any | null,

}
const Header: React.FC<HeaderProps> = ({ loginB = true, user = null, signIn, removeUser }) => {

    const siteText = translation();

    const [lan] = useState(translation().lan);

    const languages = [
        {
            name: 'Deutsch',
            ext: '/de'
        },
        {
            name: 'Français',
            ext: '/fr'
        },
        {
            name: 'English',
            ext: '/en'
        },

    ]

    const history = useIonRouter();

    const pathName = useLocation().pathname;

    const authServ = new AuthServ();

    const isAccountPage = () => {
        if (pathName.indexOf('account') < 0) return false;
        return true
    }

    const handleSignOut = async () => {
        await authServ.unSetUser();
        setPopoverSecOpen(false)
        signIn(false);
        removeUser();
        history.push(lan + '/');

    }

    const navigateDissmisMain = (link: any) => {
        setPopoverOpen(false)
        history.push(link.link);
    }

    const navigateDissmisSecondary = (link: any) => {
        setPopoverSecOpen(false)
        history.push(link.link);
    }

    const switchLan = async (e: any) => {
        let targetlan = e;
        if (targetlan === lan) {
            return;
        } else if (pathName.indexOf('home') > 0) {
            window.location.href = e
        } else {
            window.location.href = pathName.replace(lan, targetlan);
        }
    }

    const popover = useRef<HTMLIonPopoverElement>(null);
    const popoverSecondary = useRef<HTMLIonPopoverElement>(null);
    const lanPopover = useRef<HTMLIonPopoverElement>(null);

    const [popoverOpen, setPopoverOpen] = useState(false);
    const openPopover = (e: any) => {
        popover.current!.event = e;
        setPopoverOpen(true);
    };

    const [popoverSecOpen, setPopoverSecOpen] = useState(false);

    const [lanPopoverOpen, setLanPopoverOpen] = useState(false);

    const openPopoverSec = (e: any) => {
        popoverSecondary.current!.event = e;
        setPopoverSecOpen(true);
    };

    const openLanPopover = (e: any) => {
        lanPopover.current!.event = e;
        setLanPopoverOpen(true);
    };

    const openLanPopoverOnMobile=()=>{
        //setPopoverOpen(false)
        setLanPopoverOpen(true)
    }
    return (
        <>
            <IonHeader className="ion-no-border">
                <IonToolbar mode="md" className='swHeader  ion-padding-start ion-padding-end'>
                    <IonButtons slot='start'>
                        {isAccountPage() && <IonMenuButton></IonMenuButton>
                        }
                        {!isAccountPage() && <IonButton className="ion-margin-end ion-hide-md-up" fill="clear" onClick={openPopover}><IonIcon slot="icon-only" icon={menu}></IonIcon></IonButton>}
                        <Link to='/'>
                            < IonImg className="navbar_logo" src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`}></IonImg>
                        </Link>
                    </IonButtons>
                    {!isAccountPage() && <IonButtons className="ion-justify-content-center ion-hide-md-down" >
                        <IonButton routerLink={`${lan}/donate`}>{siteText.menuAccountDonateTxt}</IonButton>
                        <IonButton routerLink={`${lan}/charities`}>{siteText.menuAccountCharitiesTxt}</IonButton>
                        <IonButton routerLink={`${lan}/giftcard`}>{siteText.giftTitle}</IonButton>
                        <IonButton routerLink={`${lan}/about_us`}>{siteText.menuAccountAboutTxt}</IonButton>
                        <IonButton routerLink={`${lan}/articles`}>{siteText.menuAccountNewsTxt}</IonButton>
                    </IonButtons>}
                    <IonButtons slot="end" className=" ion-hide-md-down ion-margin-end">
                        <IonButton style={{marginRight:'30px !important'}} className="ion-margin-end" onClick={openLanPopover}>{`${lan.replace("/","").toUpperCase()}`} <IonIcon sr-only icon={chevronDown}></IonIcon></IonButton>
                    </IonButtons>
                    {user ?
                        <>
                            <IonButtons slot="end">

                                <IonText color="dark" class="ion-hide-sm-down" >{user.email}
                                </IonText>
                                <IonIcon className="ion-margin-end" size="large" color='medium' icon={personCircleOutline}></IonIcon>


                                <IonButton onClick={openPopoverSec} className="ion-margin-start ion-hide-sm-down">
                                    <IonIcon slot="icon-only" icon={appsOutline}></IonIcon>
                                </IonButton>

                            </IonButtons>


                        </>
                        : ''}
                    {loginB && !user ? <>
                        <IonButtons slot='end'>
                            <IonButton color="primary" fill="solid" routerLink={`${lan}/signup`}><IonText color="light">{siteText.createAccBtnTxt}</IonText></IonButton>
                            <IonButton  className="ion-hide-sm-down" color="secondary" fill="outline" routerLink={`${lan}/signin`}>
                                <IonIcon slot="icon-only" color="secondary" icon={personOutline}></IonIcon>
                            </IonButton>
                        </IonButtons>
                    </> : <></>
                    }
                </IonToolbar>
            </IonHeader>

            {/**login logout popover */}
            <IonPopover ref={popoverSecondary} isOpen={popoverSecOpen} onDidDismiss={() => setPopoverSecOpen(false)} showBackdrop={false}>
                <IonContent>
                    <IonList>

                    </IonList>
                    <IonItem detail={true} type="button" lines='none' onClick={() => navigateDissmisSecondary({ link: `${lan}/account/start` })}>
                        <IonIcon slot='start' ios={statsChart} md={statsChartSharp}></IonIcon>
                        <IonLabel>{siteText.menuAccountHomeTxt}</IonLabel>
                    </IonItem>
                    <IonItem detail={true} type="button" lines='none' onClick={handleSignOut}>
                        <IonIcon slot='start' ios={logOutOutline} md={logOutSharp}></IonIcon>
                        <IonLabel>{siteText.siteLogOutBtnTxt}</IonLabel>
                    </IonItem>
                </IonContent>
            </IonPopover>

            {/**menu popover */}
            <IonPopover ref={popover} isOpen={popoverOpen} showBackdrop={false} onDidDismiss={() => setPopoverOpen(false)}>
                <IonContent className="ion-padding">
                    <IonList>
                        <IonItem onClick={openLanPopoverOnMobile}>{`${lan.replace("/","").toUpperCase()}`}</IonItem>
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/signin` })}><IonText color="secondary">{siteText.siteLoginBtnTxt} </IonText><IonIcon slot="end" color="secondary" icon={logInOutline}></IonIcon></IonItem>
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/donate` })}>{siteText.menuAccountDonateTxt}</IonItem>
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/charities` })}>{siteText.menuAccountCharitiesTxt}</IonItem>
                        {/*<IonItem onClick={() => navigateDissmisMain({ link: `${lan}/fundraise` })}>{siteText.menuAccountFundraiseTxt}</IonItem>*/}
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/giftcard` })}>{siteText.giftTitle}</IonItem>
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/about_us` })}>{siteText.menuAccountAboutTxt}</IonItem>
                        {/*<IonItem onClick={() => navigateDissmisMain({ link: `${lan}/faq` })}>{siteText.menuAccountFaqTxt}</IonItem>*/}
                    </IonList>
                </IonContent>
            </IonPopover>

            {/**lan switcher desktop */}
            <IonPopover ref={lanPopover} isOpen={lanPopoverOpen} showBackdrop={false} onDidDismiss={()=>{setLanPopoverOpen(false)}}>
                <IonContent className="ion-padding">
                    <IonList>
                        {languages.map((language, key) => {
                            return <IonItem button disabled={lan===language.ext?true:false}  key={key} onClick={() => switchLan(language.ext)} >
                                <IonText color={lan === language.ext ? 'primary' : 'dark'}>{language.name}</IonText>
                                </IonItem>
                        })}
                    </IonList>
                </IonContent>
            </IonPopover>
        </>
    )
}

export default Header;

